import { NAV_PATHS } from '@modules/common/constants';
import { encodeOAuthState } from '@modules/integrationsV2/utils/encodeOAuthState';
import {
  IntegrationChannelType,
  IntegrationDirection,
  IntegrationType,
} from 'generated/graphql';

export const getRedirectUriForSlackIntegration = (
  oAuthURL: string,
  channelType: IntegrationChannelType,
  direction: IntegrationDirection,
  tenantSlug?: string,
  redirectRouteOnConnect?: string,
) => {
  return `${oAuthURL}&redirect_uri=${
    window.location.origin
  }${`/${NAV_PATHS.CONNECT_SLACK}`}&state=${encodeOAuthState({
    channelType,
    direction,
    data: {
      redirectRouteOnConnect,
      tenantSlug,
    },
    integrationType: IntegrationType.Comms,
  })}`;
};
